import { render, staticRenderFns } from "./VmChangeLogs.vue?vue&type=template&id=bcef56c8&"
import script from "./VmChangeLogs.vue?vue&type=script&lang=js&"
export * from "./VmChangeLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports